/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LootboxCartItem
 */
export interface LootboxCartItem {
    /**
     * LootBoxInstance ID for virtual purchases
     * @type {string}
     * @memberof LootboxCartItem
     */
    instanceId?: string;
    /**
     * LootBoxConfig ID for virtual purchases
     * @type {string}
     * @memberof LootboxCartItem
     */
    lootBoxConfigId?: string;
}

/**
 * Check if a given object implements the LootboxCartItem interface.
 */
export function instanceOfLootboxCartItem(value: object): value is LootboxCartItem {
    return true;
}

export function LootboxCartItemFromJSON(json: any): LootboxCartItem {
    return LootboxCartItemFromJSONTyped(json, false);
}

export function LootboxCartItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootboxCartItem {
    if (json == null) {
        return json;
    }
    return {
        
        'instanceId': json['instanceId'] == null ? undefined : json['instanceId'],
        'lootBoxConfigId': json['lootBoxConfigId'] == null ? undefined : json['lootBoxConfigId'],
    };
}

export function LootboxCartItemToJSON(json: any): LootboxCartItem {
    return LootboxCartItemToJSONTyped(json, false);
}

export function LootboxCartItemToJSONTyped(value?: LootboxCartItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instanceId': value['instanceId'],
        'lootBoxConfigId': value['lootBoxConfigId'],
    };
}

